import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'store/hook';
import {
  setActiveStep,
  setErrors,
} from 'store/SquaresStore/WorkOrderManagement/WorkOrderCreationFormState.slice';
import { validateCreationStep } from '../helpers/formValidators';

const steps = [
  {
    label: 'Work Order Creation',
    description: '',
    index: 0,
  },
  {
    label: 'Work Order Completion',
    description: '',
    index: 1,
  },
];

const statusToMaxStepMap: Record<string, number> = {
  open: 1,
  'in progress': 2,
  completed: 2,
};

export const ProgressStepper = () => {
  const dispatch = useAppDispatch();

  const activeStep = useAppSelector(
    (store) => store?.sqauresWorkOrderCreationFormReducer?.activeStep
  );

  const formData = useAppSelector(
    (state) => state?.sqauresWorkOrderCreationFormReducer?.values
  );

  // vars
  const status = formData?.status?.toLowerCase();
  const maxAllowedStep = statusToMaxStepMap[status ?? ''] ?? 2;

  const handleClickStep = (targetStep: number) => {
    if (typeof maxAllowedStep === 'number' && targetStep <= maxAllowedStep) {
      if (activeStep === 0) {
        const errors = validateCreationStep(formData);
        if (Object.keys(errors).length > 0) {
          dispatch(setErrors(errors));
          return;
        }
      }
      dispatch(setActiveStep(targetStep));
    }
  };

  return (
    <Box
      sx={{ width: { xs: '100%', md: '100%' } }}
      // height="100%"
      display={'flex'}
      flexDirection={'column'}
      padding={3}
      // border={'1px solid #e5e7eb'}
      alignItems={'center'}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        sx={{ width: { xs: '50%', md: '50%' } }}
        justifyContent={'center'}
      >
        <Stepper activeStep={activeStep} orientation="horizontal">
          {steps.map((step, index) => (
            <Step
              key={step.label}
              sx={{
                '.MuiStepLabel-label.Mui-active': { fontWeight: 'bold' },
              }}
            >
              <StepLabel
                optional={
                  step?.description ? (
                    <Typography variant="caption">
                      {step.description}
                    </Typography>
                  ) : null
                }
                onClick={() => {
                  handleClickStep(step.index);
                }}
              >
                {step.label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};
